/* RESPONSIBLE TEAM: team-actions */
import Model, { attr } from '@ember-data/model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';

export default class CaseSetupData extends Model {
  @attr('string') sectionId;
  @attr('array') caseFields;
  @attr('array') requiredCaseFields;
  @fragment('integrations/salesforce/settings') settings;
  @fragmentArray('crm/attribute-mapping') attributeMappings;
  @fragmentArray('salesforce/salesforce-fields') salesforceCaseFields;
  @fragmentArray('salesforce/salesforce-record-type') salesforceCaseRecordTypes;
}
